import { LessonActivity } from "modules/lesson/activity/activity.types"

export class LessonActivityModel {
  constructor(private data: LessonActivity) {
  }

  isCompleted(){
    return this.data.status === 1;
  }

  getRollOverDate(){
    return this.data.roll_date;
  }

  getCoinsEarned(){
    return this.data.coins_earned;
  }

}
